import { User } from './../../context/AuthContext';
import { api } from './../api';
export function getUserById(user_id: string) {
  return api.get("/user/" + user_id)
}
export function getAllUser() {
  return api.get<User[]>("/user/")
}